module.exports = __webpack_public_path__ + "static/media/Kessel105-Bold.d4ea3153.woff2";